import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getCharacterAnalysis, type CharacterAnalysisResponse } from '../api/characterAnalysis';

export const useCharacterAnalysis = (bookId?: number, options: { enabled?: boolean; isSpoil?: boolean } = {}) => {
  const isSpoil = options.isSpoil ?? false;
  return useQuery<CharacterAnalysisResponse, Error>({
    queryKey: ['character-analysis', bookId, isSpoil],
    queryFn: () => getCharacterAnalysis(bookId as number, isSpoil),
    enabled: !!bookId && options.enabled !== false,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

